/* Moonwraps - the cart drawer offer card.
 *
 * The card itself is rendered by Liquid from the real cart, so every amount is
 * already in the visitor's currency. This file only performs the swap when the
 * button is pressed, and asks the theme to re-render the drawer afterwards.
 *
 * VARIANT MODE: add one "3 caps" pack line in the shade of Cap 1 with the three
 * chosen shades as properties, then remove the single-cap lines it replaces. If
 * the removal fails, the pack line is taken back out so the cart is left exactly
 * as it was.
 * DISCOUNT MODE: add the missing single caps; the automatic discount makes the
 * third one free.
 */
(function () {
  'use strict';

  var BUSY = false;

  function root() { return document.querySelector('[data-mw-oc]'); }

  function readData(card) {
    var el = card.querySelector('[data-mw-oc-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function chosen(card, slot) {
    var el = card.querySelector('[data-mw-oc-slot="' + slot + '"]:checked');
    return el ? el.value : null;
  }

  function packVariant(data, shade) {
    var v = data.variants.filter(function (x) {
      return x.pack && x.shade === shade;
    })[0];
    return v || data.variants.filter(function (x) { return x.pack; })[0];
  }

  function singleVariant(data, shade) {
    var v = data.variants.filter(function (x) {
      return !x.pack && x.shade === shade;
    })[0];
    return v || data.variants.filter(function (x) { return !x.pack; })[0];
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) {
        throw new Error((j && j.description) || 'Request failed');
      });
      return r.json();
    });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }

  function fail(card, btn, label, message) {
    var err = card.querySelector('[data-mw-oc-err]');
    if (err) {
      err.textContent = message || 'That did not work. Please try again.';
      err.hidden = false;
    }
    btn.disabled = false;
    btn.innerHTML = label;
    BUSY = false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mw-oc-btn]');
    if (!btn || BUSY) return;

    var card = btn.closest('[data-mw-oc]');
    var data = card && readData(card);
    if (!data) return;

    e.preventDefault();
    BUSY = true;

    var label = btn.innerHTML;
    var err = card.querySelector('[data-mw-oc-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-mw-oc-busy') || 'Updating';

    var singles = data.lines.filter(function (l) { return !l.pack; });
    var inCart = data.cartShades.slice();

    /* the three shades, in order */
    var caps;
    if (data.state === 1) {
      caps = [inCart[0], chosen(card, 1), chosen(card, 2)];
    } else if (data.state === 2) {
      caps = [inCart[0], inCart[1], chosen(card, 1)];
    } else {
      caps = [inCart[0], inCart[1], inCart[2]];
    }
    caps = caps.map(function (s) { return s || data.shades[0]; });

    /* ---------------------------------------------------- discount mode */
    if (data.mode !== 'variant') {
      var want = 3 - inCart.length;
      var adds = [];
      for (var i = 0; i < want; i++) {
        var sv = singleVariant(data, caps[inCart.length + i]);
        if (sv) adds.push({ id: sv.id, quantity: 1 });
      }
      if (!adds.length) { fail(card, btn, label, 'Nothing to add.'); return; }
      post('/cart/add.js', { items: adds })
        .then(function () { refresh(); BUSY = false; })
        .catch(function (ex) { fail(card, btn, label, ex.message); });
      return;
    }

    /* ---------------------------------------------------- variant mode */
    var pv = packVariant(data, caps[0]);
    if (!pv) { fail(card, btn, label, 'That bundle is not available right now.'); return; }

    var props = { 'Cap 1': caps[0], 'Cap 2': caps[1], 'Cap 3': caps[2] };

    post('/cart/add.js', { items: [{ id: pv.id, quantity: 1, properties: props }] })
      .then(function () {
        var updates = {};
        singles.forEach(function (l) { updates[l.key] = 0; });
        if (!Object.keys(updates).length) return null;
        return post('/cart/update.js', { updates: updates }).catch(function (ex) {
          /* put the cart back the way we found it */
          var undo = {};
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            c.items.forEach(function (it) {
              if (it.variant_id === pv.id && it.properties
                && it.properties['Cap 1'] === caps[0]
                && it.properties['Cap 2'] === caps[1]
                && it.properties['Cap 3'] === caps[2]) {
                undo[it.key] = 0;
              }
            });
            if (Object.keys(undo).length) return post('/cart/update.js', { updates: undo });
            return null;
          }).then(function () { throw ex; });
        });
      })
      .then(function () { refresh(); BUSY = false; })
      .catch(function (ex) { fail(card, btn, label, ex.message); });
  });
})();
